import { useEffect, useRef } from 'react'
import { track, trackPageview } from '@/lib/analytics'
import { getModuleFromPath } from '@/lib/analytics-routes'
import { useLocation } from 'react-router-dom'

export { getModuleFromPath } from '@/lib/analytics-routes'

export function useTrackPageView(): void {
  const location = useLocation()
  // `module_opened` is deliberately coarser than a pageview: it fires when the
  // user moves BETWEEN modules, not on every route change inside one.
  const lastModuleRef = useRef<string | null>(null)

  useEffect(() => {
    trackPageview(location.pathname + location.search)
  }, [location.pathname, location.search])

  useEffect(() => {
    const module = getModuleFromPath(location.pathname)
    if (!module || module === lastModuleRef.current) return
    lastModuleRef.current = module
    track('module_opened', { module })
  }, [location.pathname])
}
